// Helper parse host từ git remote URL (https hoặc SSH) và detect GitHub host.
// Dùng để quyết định flow credential phù hợp (gh auth setup-git vs PAT manual).
//
// Supported formats:
//   https://git.nal.vn/a/b         → git.nal.vn
//   git@git.nal.vn:a/b.git         → git.nal.vn
//   https://github.com/owner/repo  → github.com
//   git@github.com:owner/repo.git  → github.com

/**
 * Parse host từ HTTPS hoặc SSH git remote URL.
 * Return null nếu URL không parse được (format lạ).
 */
export function parseGitRemoteHost(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  // HTTPS: https://host/path hoặc http://host/path
  const httpsMatch = trimmed.match(/^https?:\/\/([^/]+)/);
  if (httpsMatch) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return httpsMatch[1]!.toLowerCase();
  }

  // SSH SCP-style: git@host:path
  const sshMatch = trimmed.match(/^git@([^:]+):/);
  if (sshMatch) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return sshMatch[1]!.toLowerCase();
  }

  return null;
}

/**
 * Kiểm tra host có phải GitHub không (chỉ github.com, case-insensitive).
 * github.com → true; git.nal.vn, gitlab.com, bitbucket.org → false.
 */
export function isGithubHost(host: string | null): boolean {
  if (!host) return false;
  return host.toLowerCase() === "github.com";
}
